export const ProposalTrackingTeamPermissions = {
  ProposalTrackingTeamPermissions: {
    permissionsId: "eb970a62-1f50-4c5f-0088-08dd03ecea2b",
    permissionsName: "Proposal Tracking Team",
    description: null,
    componentsId: null,
    components: null,
  },
};
